// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uxnpxjksvjbyghgvoywq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4bnB4amtzdmpieWdoZ3ZveXdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyOTg1OTQsImV4cCI6MjA1Mjg3NDU5NH0.TPkv2Dvtg-HlWfGe7ULArBW5nkloMW8J3-O0WDGTXaM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);